import { defineComponent } from 'vue'

const ApiList = defineComponent((props: any) => {

    return () => <div style='padding: 10px;width: 260px'>
        <div style='width:100%;height:100%;background: #fff;padding: 10px;box-sizing:border-box'>
            {props.list.map((v: any) => <a
                href="javascript:void(0)"
                style='display:block;background: #f5f5f5;border-radius:4px;line-height:40px;margin-bottom: 10px;text-decoration:none;padding-left:15px;color:#666'
                onClick={() => {
                    props.onChange(v)
                }}
            >
                {v.url}
            </a>)}
        </div>
    </div>

})
ApiList.props = {
    list: Array,
    onChange: Function
}

export default ApiList;